import { getFilterDateRange } from "@/util/utils";
import couriers from "@/constants/couriers.json";

export const couriersParadas = couriers.filter((item) => item.value !== "OXPERTA");

const propias = [
  "anular",
  "cambiarEstado",
  "incidencia",
  "imagenes",
  "etiqueta",
  "comprobante",
  "excel",
  "refrescar",
];
export const vistasParadas = {
  recogidas_propias: {
    vista: "recogidas_propias",
    grupo: "Recogidas",
    titulo: "Propias",
    tipo: "RECOGIDA",
    ruta: "/franquiciadora/recogidas/propias",
    filtros: ["numero", "franquicia", "cliente", "codigoPostal"],
    enviosEnExpand: true,
    acciones: propias,
  },
  recogidas_otras_plazas: {
    vista: "recogidas_otras_plazas",
    grupo: "Recogidas",
    titulo: "Otras plazas",
    tipo: "RECOGIDA",
    ruta: "/franquiciadora/recogidas/otras-plazas",
    filtros: ["numero", "referenciaCourier", "franquicia", "cliente", "courier", "codigoPostal"],
    couriers: couriersParadas,
    enviosEnExpand: true,
    acciones: ["payload", "anular", "cambiarEstado", "incidencia", "etiqueta", "excel", "refrescar"],
  },
  recogidas_partner: {
    vista: "recogidas_partner",
    grupo: "Recogidas",
    titulo: "Partner",
    tipo: "RECOGIDA",
    ruta: "/franquiciadora/recogidas/partner",
    filtros: ["referenciaCourier", "franquicia", "courier", "codigoPostal"],
    couriers: couriersParadas.filter((item) =>
      ["SEUR", "UPS", "FEDEX"].includes(item.value),
    ),
    acciones: ["payload", "anular", "cambiarEstado", "incidencia", "excel", "refrescar"],
  },
  entregas_propias: {
    vista: "entregas_propias",
    grupo: "Entregas",
    titulo: "Propias",
    tipo: "ENTREGA",
    ruta: "/franquiciadora/entregas/propias",
    filtros: ["numero", "franquicia", "cliente", "codigoPostal"],
    enviosEnExpand: true,
    acciones: propias,
  },
};

export function filtrosParadaDefecto() {
  const hoy = new Date();
  const inicio = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate() - 12);
  const fin = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate() + 2);
  return {
    date: [inicio, fin],
    estados: [],
    conIncidencia: false,
    numero: "",
    codigoPostal: "",
    referenciaCourier: "",
    courier: "",
    franquicia: { _id: "", nombre: "", codigo: "", autocomplete: "" },
    cliente: { _id: "", autocomplete: "", generico: false, departamentos: [] },
  };
}

export function filtrosParadaUsuario(filters, config) {
  const defaults = filtrosParadaDefecto();
  const result = {
    date: getFilterDateRange(filters.date, defaults.date),
    estados: Array.isArray(filters.estados)
      ? filters.estados.filter((estado) => estado !== "INCIDENCIA")
      : [],
    // Preserve the intent of saved searches using the former incidence state.
    conIncidencia: filters.conIncidencia === true ||
      (Array.isArray(filters.estados) && filters.estados.includes("INCIDENCIA")),
  };
  config.filtros.forEach((key) => {
    result[key] = filters[key] == null ? defaults[key] : filters[key];
  });
  if (config.filtros.includes("numero")) {
    result.numero = filters.numero == null ? defaults.numero : String(filters.numero).trim();
  }
  result.codigoPostal = String(result.codigoPostal || "").trim();
  if (
    result.courier &&
    !config.couriers.some((item) => item.value === result.courier)
  )
    result.courier = "";
  return result;
}
